import { ActionIcon, Flex, TextInput } from '@mantine/core';
import { IconDotsVertical } from '@tabler/icons';
import { useStyles } from '@/containers/pages/user/components/sections/linked-emails/styles';
import { ILinkedEmail } from '@/entities/admin-app/email';
import { IUsePopUpUI, PopUpUI } from '@components/UI/PopUp';
import React from 'react';
import EmailActions from '@/containers/pages/user/components/sections/linked-emails/components/EmailActions';
import { UseFormReturnType } from '@mantine/form';

interface Props {
  email: ILinkedEmail;
  form: UseFormReturnType<any>;
  sectionFormKey: string;
  editUser?: boolean;
  currentId?: number;
  listEmails: ILinkedEmail[] | null;
  refetchUserInfo?: () => void;
}

const ActionTrigger = (props: IUsePopUpUI) => {
  const { setIsOpen } = props;

  const handleOpen = () => setIsOpen(true);

  return (
    <ActionIcon onClick={handleOpen}>
      <IconDotsVertical color="#667085" data-action="action" />
    </ActionIcon>
  );
};

export const EmailItem = (props: Props) => {
  const { email, currentId, form, sectionFormKey, listEmails, refetchUserInfo } = props;

  const { classes } = useStyles();
  console.log('email', email);
  const isVisibleChangeButton = email.Id === 0 || !email.IsIntegrated;

  return (
    <Flex className={classes.listRow}>
      <TextInput
        className={classes.nameMail}
        readOnly
        value={email.Email}
        rightSection={email.IsLdap ? <div className={classes.LDAP}>LDAP</div> : null}
      />
      <PopUpUI mobileSize="100%" desktopPosition="left-start" trigger={ActionTrigger}>
        {(params) => (
          <EmailActions
            {...params}
            currentId={currentId}
            form={form}
            email={email}
            sectionFormKey={sectionFormKey}
            listEmails={listEmails}
            isVisibleChangeButton={isVisibleChangeButton}
            refetchUserInfo={refetchUserInfo}
          />
        )}
      </PopUpUI>
    </Flex>
  );
};
